<template>
	<Character
		class="bunny"
		v-bind="$attrs"
		:content="content"
		:buttons="buttons"
		:speaking="state === 'speaking'"
	>
		<VideoSequence
			v-model="state"
			:video-map="videos"
			:transitions="transitions"
			@ended="videoEndHandler"
			:muted="$store.state.sound.muted"
		/>
	</Character>
</template>

<script>
import { mapState } from "vuex";
import characterMixins from "@/mixins/character.mixins";

export default {
	name: 'Bunny',
	mixins: [characterMixins],
	computed: {
		...mapState({
			videos: (state) => state.global.api.data.config.videos.bunny,
		}),
	},
	watch: {
		content(newContent, oldContent) {
			if (newContent !== oldContent && this.state === "exiting") {
				this.state = "entering";
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	$bunny-video-width: 25vw;
	$bunny-extra-spacing: 5vw;
	$dialogue-offset-v: 25vh;
	$dialogue-offset-h: $bunny-video-width - $bunny-extra-spacing;

	.bunny {
		--character-width: #{$bunny-video-width};
		--dialogue-offset-v: #{$dialogue-offset-v};
		--dialogue-offset-h: #{$dialogue-offset-h};

		@include mobile {
			--character-width: 20vw;
			--dialogue-offset-h: 18vw;
		}

		@include tablet {
			--character-width: #{$bunny-video-width / 1.1};
			--dialogue-offset-v: 18vh;
			--dialogue-offset-h: 22vw;
		}

		@include desktop-sm {
			--dialogue-offset-v: #{$dialogue-offset-v / .75};
			--dialogue-offset-h: #{$dialogue-offset-h / .95};
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/Bunny.vue